module.exports = __webpack_public_path__ + "fonts/roboto-all-500-italic.23683e7b.woff";